import CreditName from 'src/components/rewards/customisation/CreditName'
import SaveNotification from 'src/components/common/SaveNotification'
import EarnMessage from './EarnMessage'
import EarnTileCustomiseUI from './EarnTileCustomiseUI'
import { useRewardsContext } from 'src/lib/contexts/RewardsConfigContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import { Switch } from '@mui/material'
import FormTile from 'src/components/common/containers/FormTile'
import { useState } from 'react'
import FloGenericDialog from 'src/components/common/feedback-and-dialog/GenericDialog'
import { useRewardsPermissions } from 'src/lib/access-permission-hooks/useRewardsPermissions'
const CustomisationTab = () => {
  const { t } = useLocale()
  const initialRewardsConfig = useRewardsContext(context => context.initialRewardsConfig)
  const presentState = useRewardsContext(context => context.state)
  const setDiscardChanges = useRewardsContext(context => context.actions?.setDiscardChanges)
  const setSaveChanges = useRewardsContext(context => context.actions?.setSaveChanges)
  const earnMessage = useRewardsContext(context => context.state?.earnMessage)
  const setEarnMessage = useRewardsContext(context => context.actions?.setEarnMessage)
  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false)

  const { canEditRewardsCustomisation } = useRewardsPermissions()

  return (
    <>
      <div className='flex flex-row w-8/12'>
        <div className='flex  w-full gap-4 '>
          <div className='flex flex-col w-full gap-4 padding: 16px 16px 0px 16px'>
            {/* Credit name and earn messages */}
            <CreditName />
            <FormTile
              title={t('earn_tile_customization')}
              endComponent={
                <Switch
                  name='toggler'
                  disabled={!canEditRewardsCustomisation}
                  checked={earnMessage?.enable}
                  onChange={() => {
                    if (earnMessage?.enable) {
                      setShowConfirmationDialog(true)
                      return
                    }
                    setEarnMessage({ ...earnMessage, enable: !earnMessage?.enable })
                  }}
                />
              }
            >
              <div className='border-t-1  -mx-4'></div>
              <EarnMessage />
              <EarnTileCustomiseUI />
            </FormTile>
          </div>
        </div>
      </div>
      {Boolean(showConfirmationDialog) && (
        <FloGenericDialog
          width={800}
          isOpen={showConfirmationDialog}
          handleClose={() => {
            setShowConfirmationDialog(false)
          }}
          content={
            <p className='text-sm text-coal-dark'>
              {t('default_messages_will_be_shown_are_you_sure_you_want_to_proceed')}
            </p>
          }
          referrer='changes-cancel-confirmation'
          title={t('turn_off_earn_message')}
          jobButtonText={'Confirm'}
          closeButtonText={'Cancel'}
          handleJob={async () => {
            setEarnMessage({
              ...earnMessage,
              enable: false,
              line_1: `${t('earn_message_line_1')}`,
              line_2: `${t('earn_message_line_2')}`
            })
            setShowConfirmationDialog(false)
          }}
          primaryBtnCss={{ backgroundColor: '!important', outline: 'none', hover: 'none' }}
        />
      )}
      <SaveNotification
        onSave={() => {
          setSaveChanges(presentState)
        }}
        onDiscard={setDiscardChanges}
        isVisible={JSON.stringify(presentState) !== JSON.stringify(initialRewardsConfig)}
      />
    </>
  )
}

export default CustomisationTab
